import logo from './logo.svg';
import './App.css';
import MyComponent from './App.jsx';

function App() {
  return <MyComponent />;
}

export default App;
